import React from 'react';
import BaseDate from '../base-date-picker';
import { AddFunnelPropFromContext } from '../funnel-context';
import { FUNNELS, LABELS as DEFAULT_LABELS } from '../../util/constants';
const LABELS = {
  ARHI: DEFAULT_LABELS.DATE_INPUT
};
const DateInput = props => {
  const {
    funnel = FUNNELS.ARHI
  } = props;
  return React.createElement(BaseDate, {
    ...props,
    label: props.label || LABELS[funnel] || LABELS.ARHI,
    funnel: funnel
  });
};
const DateInputWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(DateInput, {
  ...props
}));
export default DateInputWithFunnel;